import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-800 text-stone-300 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo & Name */}
          <div className="flex items-center gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_7b22c07b-667b-4a40-bcbb-730ee8179145/artifacts/bl4hg88i_IMG_2010.png"
              alt="Avícola Santa Adara"
              className="w-12 h-12 rounded-full object-cover"
            />
            <div>
              <p className="font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
                Avícola Santa Adara
              </p>
              <p className="text-sm text-stone-400">Copiapó, Chile</p>
            </div>
          </div>

          {/* Links */}
          <div className="flex gap-6">
            <a 
              href="https://wa.me/56988985009"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-amber-400 transition-colors"
              data-testid="footer-whatsapp"
            >
              WhatsApp
            </a>
            <a 
              href="https://instagram.com/avicola_santa_adara"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-amber-400 transition-colors"
              data-testid="footer-instagram"
            >
              Instagram
            </a>
            <a 
              href="https://www.tiktok.com/@avicola.santa.adara"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-amber-400 transition-colors"
              data-testid="footer-tiktok"
            >
              TikTok
            </a>
          </div>

          {/* Copyright */}
          <div className="flex items-center gap-2 text-sm">
            <span>© {currentYear} Avícola Santa Adara</span>
            <span className="text-stone-500">•</span>
            <span className="flex items-center gap-1">
              Hecho con <Heart className="w-4 h-4 text-amber-500" /> en Copiapó
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
